function Banner() {
    return (
        <div className="mid-box">
            <div className="left-box">
                <h1 className="f-bold">¡APRENDE CON NOSOTROS!</h1>
                <p>El yoga es para quien desea mejorar como ser humano, 
                    para quien desea sentirse bien consigo mismo y encontrar 
                    un sentido a su vida.
                </p>
            </div>
            <div className="right-box">
            </div>
        </div>
    )
}

export default Banner;